import React, { useReducer } from "react";



import { toast } from "react-toastify";







import TransactionContext from "../context/TransactionContext";
import { TransactionReducer } from "../reducer/TransactionReducer";
import {
  createTransactionService,
  getTransactionService,
} from "src/core/services/transactions.service";
import {
  CREATE_TRANSACTION,
  CREATE_TRANSACTION_ERROR,
  GET_TRANSACTIONS,
  GET_TRANSACTION_ERROR,
  SET_TRANSACTION_LOADING,
} from "../types/transaction.type";

const initialTransaction = {
  transaction: null,
  transactions: [],
  loading: false,
  error: null,
  isCompleted: false,
};

export const TransactionProvider = ({ children }) => {
  const [transaction, transactionDispatch] = useReducer(
    TransactionReducer,
    initialTransaction
  );
  const loading = (isLoading: boolean) => ({
    type: SET_TRANSACTION_LOADING,
    isLoading,
  });

  // function to get transactions
  const getTransactions = async (data) => {
    transactionDispatch(loading(true));
    try {
      const response = await getTransactionService(data);
      if (response.data.data.findTransactions.transactions) {
        const transactions = response.data.data.findTransactions.transactions;
        console.log(transactions);

        transactionDispatch({ type: GET_TRANSACTIONS, payload: transactions });
      } else {
        toast.error("cannot fetch trasaction for user");
        transactionDispatch(loading(false));

        // toast.success("Account created successfully");
      }
      transactionDispatch(loading(false));
    } catch (error: any) {
      transactionDispatch({
        type: GET_TRANSACTION_ERROR,
        payload: error?.response?.data?.errors,
      });
      // toast.error("Error occured while fetching transactions");
      transactionDispatch(loading(false));
    }
  };
  const createTransaction = async (
    isBankFound = false,
    transactionDetail,
    user
  ) => {
    transactionDispatch(loading(true));
    try {
      const response = await createTransactionService(
        isBankFound,
        transactionDetail,
        user
      );
      console.log(response);

      if (response.data.data.transaction.object) {
        const resTransaction = JSON.parse(response.data.data.transaction.object);
        console.log(resTransaction);

        transactionDispatch({
          type: CREATE_TRANSACTION,
          payload: resTransaction,
        });
        toast.success("transaction is  successfull");
      } else {
        transactionDispatch({
          type: CREATE_TRANSACTION_ERROR,
          payload: response?.data?.errors,
        });
        toast.error("an error occured while craeting transaction");
        //   toast.
      }

      transactionDispatch(loading(false));
    } catch (error: any) {
      // console.log(error);
      transactionDispatch({
        type: CREATE_TRANSACTION_ERROR,
        payload: error?.response?.data?.errors,
      });
      toast.error("Error occured while, please check your internet settings");
      transactionDispatch(loading(false));
    }
  };

  return (
    <TransactionContext.Provider
      value={{
        transaction,
        transactionDispatch,
        getTransactions,
        createTransaction,
      }}
    >
      {children}
    </TransactionContext.Provider>
  );
};
